import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 820;

export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT): boolean {
	const [isMobile, setIsMobile] = useState(
		() => globalThis.matchMedia(`(max-width: ${breakpoint}px)`).matches,
	);

	useEffect(() => {
		const mediaQuery = globalThis.matchMedia(`(max-width: ${breakpoint}px)`);
		function handleChange(event: MediaQueryListEvent) {
			setIsMobile(event.matches);
		}

		mediaQuery.addEventListener("change", handleChange);
		return () => mediaQuery.removeEventListener("change", handleChange);
	}, [breakpoint]);

	return isMobile;
}
